document.addEventListener("DOMContentLoaded", function () {
  const locationContainer = document.querySelector(".opt-location");
  const colorBlockOriginal = document.querySelector(".opt-number_of_color");

  const colorBlockTemplate = colorBlockOriginal.cloneNode(true);
  colorBlockOriginal.style.display = "none"; // Hide original
  const parentContainer = colorBlockOriginal.parentElement;

  function slugify(text) {
    return text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '');
  }

  function generateColorBlock(locationName) {
    const clone = colorBlockTemplate.cloneNode(true);
    clone.style.display = "block";
    const slug = slugify(locationName);

    const inputName = `properties[Number of color - ${locationName}]`;
    const inputName2 = `Number of color - ${locationName}`;

    const title = clone.querySelector(".cu-ai-radio-options__title");
    if (title) {
      title.innerHTML = `Select Number of Colors (<strong>${locationName}</strong>)`;
    }

    const radios = clone.querySelectorAll('input[type="radio"]');
    const labels = clone.querySelectorAll('label');

    radios.forEach((radio, index) => {
      const uniqueId = `color-${slug}-${index + 1}`;
      radio.name = inputName;
      radio.id = uniqueId;
      radio.checked = false;

      if (labels[index]) {
        labels[index].setAttribute("for", uniqueId);
        labels[index].setAttribute("data-product-option-val", inputName2);
      }
    });

    if (radios[0]) radios[0].checked = true;

    return clone;
  }

  function renderColorBlocks() {
    parentContainer.querySelectorAll(".opt-number_of_color:not([style*='display: none'])").forEach(el => el.remove());

    const selectedCheckboxes = locationContainer.querySelectorAll('input[type="checkbox"]:checked');

    selectedCheckboxes.forEach(cb => {
      const locationName = cb.value;
      const colorBlock = generateColorBlock(locationName);
      parentContainer.appendChild(colorBlock);
    });
  }

  const checkboxes = locationContainer.querySelectorAll('input[type="checkbox"]');
  
  checkboxes.forEach(cb => cb.checked = false);

  if (checkboxes.length > 0) {
    checkboxes[0].checked = true;
  }

  checkboxes.forEach(cb => {
    cb.addEventListener("change", renderColorBlocks);
  });

  renderColorBlocks();
});
